import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";

export default function LinearGraph() {
  const [smallViewWidth, setisSmallviewWidth] = useState(false);
  useEffect(() => {
    window.innerWidth < 1192
      ? setisSmallviewWidth(true)
      : setisSmallviewWidth(false);

    window.addEventListener("resize", () => {
      window.innerWidth < 1192
        ? setisSmallviewWidth(true)
        : setisSmallviewWidth(false);
    });
  }, []);

  useEffect(() => {
    const options = {
      series: [
        {
          name: "Sales",
          data: [31, 40, 28, 51, 42, 82, 56],
        },
        {
          name: "Revenue",
          data: [11, 32, 45, 32, 34, 52, 41],
        },
        {
          name: "Customers",
          data: [15, 11, 32, 18, 9, 24, 11],
        },
      ],
      chart: {
        height: smallViewWidth ? "35%" : "80%",
        type: "area",
        toolbar: {
          show: false,
        },
      },
      markers: {
        size: 4,
      },
      colors: ["#4154f1", "#2eca6a", "#ff771d"],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.3,
          opacityTo: 0.4,
          stops: [0, 90, 100],
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      xaxis: {
        type: "datetime",
        categories: [
          "2018-09-19T00:00:00.000Z",
          "2018-09-19T01:30:00.000Z",
          "2018-09-19T02:30:00.000Z",
          "2018-09-19T03:30:00.000Z",
          "2018-09-19T04:30:00.000Z",
          "2018-09-19T05:30:00.000Z",
          "2018-09-19T06:30:00.000Z",
        ],
        labels: {
          style: {
            colors: "#f3f3f3", // Change the color of x-axis labels
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#f3f3f3", // Change the color of y-axis labels
          },
        },
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
      legend: {
        labels: {
          colors: "#f3f3f3", // Change the color of legend labels
        },
      },
    };

    const chart = new ApexCharts(
      document.querySelector("#reportsChart"),
      options
    );
    chart.render();

    // Cleanup function to destroy the chart on component unmount
    return () => {
      chart.destroy();
    };
  }, [smallViewWidth]);

  return <div id="reportsChart" className="reportsChart"></div>;
}
